import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiColumn } from 'foundations-components/transitional/components/MultiColumn';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { getFlattenedTeamsMap, getSortedFlattenedTeamsList, getAllParentTeamIdsForChildTeamId } from '../../utils/TeamUtils';
import SelectedTeamOption from './SelectedTeamOption';
import SelectedUserOption from './SelectedUserOption';
import useBulkFetchUsers from '../../hooks/useBulkFetchUsers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Adds additional information used for displaying a team in the access status component.
const makeTeamOption = ({
  team,
  teams,
  teamMap,
  userHasTeamAssignmentScope,
  rootLevelTeamIds,
  useOnlyPrimaryMembers
}) => {
  return Object.assign({}, team, {
    totalTeamMembers: team.userIds.length + (useOnlyPrimaryMembers ? 0 : team.secondaryUserIds.length),
    fullParentNameList: getAllParentTeamIdsForChildTeamId(team.id, teams).map(parentId => teamMap[parentId].name),
    userCanRemoveTeam: userHasTeamAssignmentScope || !rootLevelTeamIds.includes(team.id)
  });
};
const UsersAndTeamsAccessStatus = ({
  teams,
  selectedUserIds,
  selectedTeamIds,
  userIdsForSelectedTeamIds,
  onRemoveUser,
  onRemoveTeam,
  rootLevelTeamIds,
  userHasTeamAssignmentScope,
  maxHeight = 200,
  disallowedUserTooltip,
  disabledUsers,
  allowedUserIds,
  hideTitle,
  useOnlyPrimaryMembers = false,
  selectedUserInfo
}) => {
  const {
    users
  } = useBulkFetchUsers(selectedUserIds, userIdsForSelectedTeamIds);
  const getSelectedTeamOptions = () => {
    const teamMap = getFlattenedTeamsMap(teams);
    const teamList = getSortedFlattenedTeamsList(teams).filter(({
      id
    }) => selectedTeamIds.includes(id)).map(team => makeTeamOption({
      team,
      teams,
      teamMap,
      userHasTeamAssignmentScope,
      rootLevelTeamIds,
      useOnlyPrimaryMembers
    }));
    return teamList;
  };
  const getExplicitlySelectedUserOptions = () => {
    return users.filter(user => {
      return selectedUserIds.includes(user.id) && !userIdsForSelectedTeamIds.includes(user.id);
    });
  };
  const renderTeamOption = team => {
    const {
      id,
      name,
      totalTeamMembers,
      fullParentNameList,
      userCanRemoveTeam
    } = team;
    return /*#__PURE__*/_jsx(SelectedTeamOption, {
      id: id,
      name: name,
      totalTeamMembers: totalTeamMembers,
      fullParentNameList: fullParentNameList,
      onRemoveTeam: onRemoveTeam,
      userCanRemoveTeam: userCanRemoveTeam
    }, id);
  };
  const renderUserOption = user => {
    const {
      id,
      email
    } = user;
    let canRemoveUser = true;
    if (disabledUsers) canRemoveUser = !disabledUsers.includes(user.id);else if (allowedUserIds) canRemoveUser = allowedUserIds.includes(user.id);
    return /*#__PURE__*/_jsx(SelectedUserOption, {
      user: user,
      id: id,
      selectedUserInfo: selectedUserInfo,
      email: email,
      canRemoveUser: canRemoveUser,
      disallowedUserTooltip: disallowedUserTooltip,
      onRemoveUser: onRemoveUser
    }, id);
  };
  const teamOptions = getSelectedTeamOptions();
  const userOptions = getExplicitlySelectedUserOptions();
  if (teamOptions.length === 0 && userOptions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!hideTitle && /*#__PURE__*/_jsx(FormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.labels.whoHasAccess"
      })
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: maxHeight,
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsxs(MultiColumn, {
        children: [teamOptions.map(renderTeamOption), userHasTeamAssignmentScope && userOptions.map(renderUserOption)]
      })
    })]
  });
};
export default UsersAndTeamsAccessStatus;